<div class="flex-fill d-flex flex-column w-100">
    <div class="date-select-card">
        <div class="d-flex flex-row align-items-center">
            <label class="me-2">Schedule Date</label>
            <dx-date-box [(value)]="scheduleDate" (onValueChanged)="onDateChanged()" [width]="'150px'"></dx-date-box>
            <button (click)="changeDate(-1)" class="btn btn-sm btn-success ms-2 me-2" style="min-width: 80px">Previous</button>
            <button (click)="changeDate(1)" class="btn btn-sm btn-success me-2" style="min-width: 80px">Next</button>
            <button class="btn btn-sm btn-secondary me-2" (click)="refresh()">Refresh Data</button>
            <label class="schedule-date ms-3">{{ displayDate }}</label>
            <button class="btn btn-sm btn-success ms-2" (click)="print()">Print Day</button>
            <button class="btn btn-sm btn-success ms-2" (click)="print(null, { printWeek: true })">Print Week</button>
            <button class="btn btn-sm ms-2" [ngClass]="isDayLocked ? 'btn-secondary' : 'btn-danger'" (click)="toggleDayLock()">
                {{ isDayLocked ? 'Unlock Day' : 'Lock Day' }}
            </button>
            <button class="btn btn-sm ms-2" [ngClass]="viewMode === 'week' ? 'btn-primary' : 'btn-outline-primary'" (click)="toggleViewMode()">
                {{ viewMode === 'week' ? 'Day View' : 'Week View' }}
            </button>

            <div class="d-flex align-items-center me-3">
                <label class="ms-3 me-1">Assembly Jigs</label>
                <dx-tag-box
                    style="min-width: 250px; max-width: 500px"
                    [(value)]="filter.assemblyJigIds"
                    [items]="allAssemblyJigs"
                    [valueExpr]="'id'"
                    [displayExpr]="'name'"
                    [showSelectionControls]="true"
                    [showDropDownButton]="true"
                ></dx-tag-box>
                <button class="btn btn-sm btn-success ms-2" (click)="applyJigFilter()">Apply</button>
            </div>
        </div>
    </div>
    <div id="kanban" class="flex-fill d-flex flex-row">
        <div *ngIf="unAssignedJobs" class="d-flex flex-column">
            <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="1" (onEditorEnterKey)="search()" width="95%">
                <dxi-item itemType="group">
                    <dxi-item
                        dataField="dealerId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Dealer' }"
                        [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'companyName' }"
                    ></dxi-item>
                    <dxi-item itemType="group" [colCount]="2">
                        <dxi-item dataField="dealerName" [label]="{ text: 'Dealer' }"></dxi-item>
                        <dxi-item [label]="{ text: ' ' }">
                            <div *dxTemplate>
                                <dx-select-box [(value)]="filter.dealerFilterOp" [items]="filterOps"> </dx-select-box>
                            </div>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item dataField="salesOrderNumber" editorType="dxNumberBox" [label]="{ text: 'Sales Order #' }"></dxi-item>
                    <dxi-item dataField="partNumber"></dxi-item>
                    <dxi-item dataField="startDate" [label]="{ text: 'Start' }" editorType="dxDateBox" [editorOptions]="{ width: '150px' }"></dxi-item>
                    <dxi-item dataField="endDate" [label]="{ text: 'End' }" editorType="dxDateBox" [editorOptions]="{ width: '150px' }"></dxi-item>
                    <dxi-item dataField="includeOnHold" editorType="dxCheckBox" [label]="{ text: 'Include On Hold' }"></dxi-item>
                    <!-- <dxi-item dataField="vIN" [label]="{ text: 'VIN' }"></dxi-item> -->
                </dxi-item>
            </dx-form>
            <div class="mt-2">
                <button class="btn btn-sm btn-secondary me-2" (click)="search()">Search</button>
                <button class="btn btn-sm btn-secondary" (click)="clear()">Clear</button>
            </div>

            <div class="flex-fill d-flex flex-row">
                <div class="d-flex flex-column">
                    <div class="list-title dx-theme-text-color">{{ 'UnAssigned Details' }}</div>
                    <div *ngIf="!unAssignedJobs || unAssignedJobs.length === 0" class="list-title dx-theme-text-color">{{ 'NO DATA' }}</div>
                    <dx-scroll-view class="scrollable-list" direction="vertical" showScrollbar="always">
                        <dx-sortable
                            class="sortable-cards"
                            group="cardsGroup"
                            [data]="unAssignedJobs"
                            (onDragStart)="onTaskDragStart($event)"
                            (onReorder)="onTaskDrop($event)"
                            (onAdd)="onTaskDrop($event)"
                        >
                            <ng-container *ngFor="let job of unAssignedJobs.assignedJobs">
                                <ng-container *ngTemplateOutlet="unassignedCard; context: { $implicit: job }"></ng-container>
                            </ng-container>
                        </dx-sortable>
                    </dx-scroll-view>
                </div>
                <div class="d-flex flex-column">
                    <div *ngIf="uncompletedJobs && uncompletedJobs.length > 0" class="list-title dx-theme-text-color" (click)="openDetailDialog(uncompletedJobs)">
                        Previous UnCompleted Jobs: {{ uncompletedJobs?.length }}
                    </div>
                    <div class="list-title dx-theme-text-color">Daily Production Capacity: {{ dailyProductionCapacity }}</div>
                    <!-- <div class="ms-2 mb-2"><label class="me-2"></label></div> -->
                    <div *ngIf="projectedJobs" class="list-projection">
                        <div class="list-title dx-theme-text-color">Day's Projection -- {{ projectedJobs.assignedJobs.length }}</div>
                        <div *ngIf="isDayLocked" class="text-center mt-2 day-locked">Day locked</div>
                        <div *ngIf="!isDayLocked && dayLockNotes.length > 0" class="text-center mt-2 lock-history-toggle" (click)="showLockHistory = !showLockHistory">
                            <i class="fa me-1" [ngClass]="showLockHistory ? 'fa-caret-down' : 'fa-caret-right'"></i>Lock History ({{ dayLockNotes.length }})
                        </div>
                        <div *ngIf="dayLockNotes.length > 0 && (isDayLocked || showLockHistory)" class="ms-2 me-2 card-detail other">
                            <div *ngFor="let note of dayLockNotes">{{ note.created | date: 'MM/dd/yyyy h:mm aa' }} {{ note.createdBy }}: {{ note.notes }}</div>
                        </div>

                        <dx-scroll-view class="scrollable-list" direction="vertical" showScrollbar="always">
                            <dx-sortable class="sortable-cards" group="cardsGroup" [data]="projectedJobs" (onDragStart)="onTaskDragStart($event)">
                                <ng-container *ngFor="let job of projectedJobs.assignedJobs">
                                    <ng-container *ngTemplateOutlet="unassignedCard; context: { $implicit: job }"></ng-container>
                                </ng-container>
                            </dx-sortable>
                        </dx-scroll-view>
                    </div>
                </div>
            </div>
        </div>

        <dx-scroll-view *ngIf="viewMode === 'day'" class="scrollable-board" direction="horizontal" showScrollbar="always">
            <dx-sortable
                class="sortable-lists"
                [data]="jigColumns"
                itemOrientation="horizontal"
                handle=".list-title"
                (onDragStart)="onListDragStart($event)"
                (onReorder)="onListReorder($event)"
            >
                <div class="list" *ngFor="let jig of jigColumns">
                    <div id="jig-card" class="list-title dx-theme-text-color" (contextmenu)="onJigContextMenu(jig.id)">{{ jig.name }} -- Est.Time: {{ jig.estimatedTime }}</div>
                    <div *ngFor="let member of jig.teamMembers" class="ms-2">{{ member.userName }}<i class="ms-1 fa fa-times" (click)="deleteJigMember(member)"></i></div>
                    <div *ngIf="jig.jigNotes?.length > 0" class="jig-notes">
                        Jig Notes:
                        <div *ngFor="let note of jig.jigNotes" class="ms-2">
                            {{ note.notes }}
                            <i class="ms-1 fa fa-pencil" (click)="editJigNote(note)"></i>
                            <i class="ms-1 fa fa-times" (click)="deleteNote(note)"></i>
                        </div>
                    </div>

                    <dx-scroll-view class="scrollable-list" direction="vertical" showScrollbar="always">
                        <dx-sortable
                            class="sortable-cards"
                            group="cardsGroup"
                            [data]="jig"
                            (onDragStart)="onTaskDragStart($event)"
                            (onReorder)="onTaskDrop($event)"
                            (onAdd)="onTaskDrop($event)"
                        >
                            <ng-container *ngFor="let assignedJob of jig.assignedJobs">
                                <ng-container *ngTemplateOutlet="assignedJobCard; context: { $implicit: assignedJob }"></ng-container>
                            </ng-container>
                        </dx-sortable>
                    </dx-scroll-view>
                </div>
            </dx-sortable>
        </dx-scroll-view>

        <dx-scroll-view *ngIf="viewMode === 'week'" class="scrollable-board" direction="horizontal" showScrollbar="always">
            <div class="week-board">
                <div class="week-day-col" *ngFor="let dayGroup of weekDayColumns">
                    <div class="week-day-header">{{ dayGroup.dayLabel }}</div>
                    <dx-scroll-view class="week-day-scroll" direction="vertical" showScrollbar="always">
                        <div class="week-jig-section" *ngFor="let jigCol of dayGroup.jigs">
                            <div class="week-jig-subheader">{{ jigCol.jigName }}</div>
                            <dx-sortable
                                class="sortable-cards"
                                group="cardsGroup"
                                [data]="jigCol"
                                (onDragStart)="onTaskDragStart($event)"
                                (onReorder)="onWeekTaskDrop($event)"
                                (onAdd)="onWeekTaskDrop($event)"
                            >
                                <ng-container *ngFor="let assignedJob of jigCol.assignedJobs">
                                    <ng-container *ngTemplateOutlet="assignedJobCard; context: { $implicit: assignedJob }"></ng-container>
                                </ng-container>
                            </dx-sortable>
                        </div>
                    </dx-scroll-view>
                </div>
            </div>
        </dx-scroll-view>
    </div>
</div>
<ng-template #assignedJobCard let-assignedJob>
    <div
        id="job-card"
        [class]="
            'flex-row card dx-card dx-theme-text-color dx-theme-background-color text-wrap' +
            (assignedJob.buildComplete ? ' card-completedJob' : '') +
            (assignedJob.built ? ' card-built' : '')
        "
        (contextmenu)="onContextMenu(assignedJob.id)"
        [title]="assignedJob.shipAddressNotes || ''"
    >
        <div class="flex-fill">
            <div *ngIf="!assignedJob.buildComplete" class="card-priority" [ngClass]="'priority-' + assignedJob.jobTypeId"></div>
            <div class="card-detail dealer">
                {{ assignedJob.orderLine?.order?.dealer?.companyName }}{{ assignedJob.shipToCityDisplay ? ' - ' + assignedJob.shipToCityDisplay : '' }}
            </div>
            <div class="card-detail other">
                <a [routerLink]="[]" (click)="openDetailDialog(assignedJob)" name="Options"
                    >Order: {{ assignedJob.orderLine?.order?.invoiceNumber }} -- Detail: D{{ assignedJob.id }}</a
                >
            </div>
            <div class="card-detail other">Part: {{ assignedJob.orderLine?.partNumber }}</div>
            <!-- <div *ngIf="!assignedJob.buildComplete" class="card-detail other">{{ assignedJob.orderLine?.description }}</div> -->
            <div class="card-detail other">BuildTime: {{ assignedJob.buildTime }}</div>
            <div class="card-detail dealer">VIN: {{ assignedJob.vIN }}</div>
            <div class="card-detail other">Due: {{ assignedJob.buildDue | date: 'E MM/dd/yy' }}</div>
            <div *ngIf="assignedJob.assemblyNotes?.length > 0" class="card-detail dealer build-note">
                <div *ngFor="let note of assignedJob.assemblyNotes">
                    Build Note: {{ note.createDate | date: 'MM/dd/yyyy h:mm aa' }} {{ note.createdBy.userName }}: {{ note.note }}
                    <i class="ms-1 fa fa-pencil" (click)="editNote(note)"></i>
                    <i class="ms-1 fa fa-times" (click)="deleteNote(note)"></i>
                </div>
            </div>
            <div *ngIf="assignedJob.preAssemblyNotes?.length > 0" class="card-detail other pre-assembly-note scheduled">
                <div *ngFor="let note of assignedJob.preAssemblyNotes">
                    {{ note.createDate | date: 'MM/dd/yyyy h:mm aa' }} {{ note.createdBy.userName }}: {{ note.note }}
                    <i class="ms-1 fa fa-pencil" (click)="editNote(note)"></i>
                    <i class="ms-1 fa fa-times" (click)="deleteNote(note)"></i>
                </div>
            </div>
        </div>
        <div class="d-flex flex-fill align-items-center" style="min-width: 10px; max-width: 10px"></div>
    </div>
</ng-template>
<ng-template #unassignedCard let-job>
    <div
        id="unassigned-job-card"
        class="card dx-card dx-theme-text-color dx-theme-background-color text-wrap"
        [class.card-on-hold]="job.onHold"
        (contextmenu)="onContextMenu(job.id)"
        [title]="job.shipAddressNotes || ''"
    >
        <div *ngIf="job.onHold" class="card-detail dealer">ON HOLD</div>
        <div class="card-priority" [ngClass]="'priority-' + job.Task_Priority + (job.warranty ? ' warranty-card' : '')"></div>
        <div class="card-detail dealer">{{ job.orderLine?.order?.dealer?.companyName }}{{ job.shipToCityDisplay ? ' - ' + job.shipToCityDisplay : '' }}</div>
        <div class="card-detail other">
            <a [routerLink]="[]" (click)="openDetailDialog(job)" name="Options">Order: {{ job.orderLine?.order?.invoiceNumber }}</a>
        </div>
        <div class="card-detail other">Part: {{ job.orderLine?.partNumber }}</div>
        <!-- <div class="card-detail other">{{ job.orderLine?.description }}</div> -->
        <div class="card-detail other">{{ job.vIN }}</div>
        <div class="card-detail other">Due: {{ job.buildDue | date: 'E MM/dd/yy' }}</div>
        <div *ngIf="job.preAssemblyNotes?.length > 0" class="card-detail other pre-assembly-note">
            <div *ngFor="let note of job.preAssemblyNotes">
                {{ note.createDate | date: 'MM/dd/yyyy h:mm aa' }} {{ note.createdBy.userName }}: {{ note.note }}
                <i class="ms-1 fa fa-pencil" (click)="editNote(note)"></i>
                <i class="ms-1 fa fa-times" (click)="deleteNote(note)"></i>
            </div>
        </div>
    </div>
</ng-template>
<dx-context-menu target="#jig-card" [dataSource]="jigContextMenuItems" (onItemClick)="onJigContextMenuItemClick($event)"> </dx-context-menu>
<dx-context-menu target="#job-card" [dataSource]="jobContextMenuItems" (onItemClick)="onContextMenuItemClick($event)"> </dx-context-menu>
<dx-context-menu
    target="#unassigned-job-card"
    [dataSource]="unassignedJobContextMenuItems"
    (onShowing)="onUnassignedContextMenuShowing($event)"
    (onItemClick)="onContextMenuItemClick($event)"
>
</dx-context-menu>
